module.exports = __webpack_public_path__ + "static/media/portfolio.7beabe54.png";